import config from '../../../config';
import {
  useOrganizationFlagsQuery,
  useOrgFlagsQuery,
} from '../../../generated/graphql';
import {jsonParseSafe} from '../../../util/json';
import {DEFAULT_ONPREM_ORGANIZATION_NAME} from '../../OrgDashboard/OrgRoles/RolesDashboard';

const isOnPrem = config.ENVIRONMENT_IS_PRIVATE;

export interface OrgVisibilityEnforcement {
  orgPrivateOnly: boolean;
  orgHidden: boolean;
}

/**
 * Reads the org-level "Enforce private projects" and "Enforce team visibility
 * restrictions" flags for a team. Server teams are not always linked to an
 * org, so on-prem reads the default org by name, matching TeamSettings.
 * Flags that cannot be read count as not enforced.
 */
export function useOrgVisibilityEnforcement(
  organizationId: string | undefined,
  skip: boolean
): OrgVisibilityEnforcement {
  const {data: onPremData} = useOrganizationFlagsQuery({
    variables: {orgName: DEFAULT_ONPREM_ORGANIZATION_NAME},
    skip: skip || !isOnPrem,
  });
  const {data: cloudData} = useOrgFlagsQuery({
    variables: {organizationId: organizationId ?? ''},
    skip: skip || isOnPrem || !organizationId,
  });

  const rawFlags = isOnPrem
    ? onPremData?.organization?.flags
    : cloudData?.organization?.flags;
  const flags = rawFlags != null ? (jsonParseSafe(rawFlags) ?? {}) : {};

  return {
    orgPrivateOnly: flags.private_projects === true,
    orgHidden: flags.is_hidden === true,
  };
}
